import React from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import warnings from 'components/Modal/DevWarnings'
import { isProd } from 'config/api.config'
import { useSelector } from 'hooks'

window.warn = (name, msg) => {
  console.warn(name, msg)
  const wrapper = document.getElementById('dev-warnings')
  if (!wrapper) {
    return
  }
  const id = `dw${name}`
  const el =
    wrapper.querySelector(`#${id}`) || wrapper.appendChild(Object.assign(document.createElement('div'), { id }))
  const Component = warnings[name]
  ReactDOM.render(<Component />, el)
}

const DevWarnings = () => {
  const email = useSelector(s => s.myProfile.email)

  if (isProd && !/datingfactory.com$/.test(email)) {
    return null
  }

  return <StyledWarnings id="dev-warnings" />
}

const StyledWarnings = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  font-size: 1.2rem;
  > div {
    margin: 1em;
    padding: 1.5em;
    border-radius: 1em;
    position: relative;
    background: rgba(200, 200, 100, 0.95);
    box-shadow: 0 0 2px 1px;
  }
  a {
    cursor: pointer;
    display: inline-block;
    border-radius: 50%;
    font: bold 3rem monospace;
    width: 1em;
    line-height: 1;
    text-align: center;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%) scale(1.001);
    background: rgba(200, 200, 200, 0.95);
    box-shadow: 0 0 2px 1px;
    transition: 0.2s;
    backface-visibility: hidden;
    &:hover {
      background: rgb(200, 200, 200);
      transform: translate(50%, -50%) scale(1.2);
    }
  }
`

export default DevWarnings
